<template>
	<div v-if="flight">
		<CModal title="Modifier le vol" size="lg" :show.sync="showModal">
			<form
				ref="mainForm"
				:action="['/api/flights/', flight.id].join('')"
				method="post"
				axiosMethod="patch">
				<FormContent v-if="showModal" ref="form" :flight="flight" :key="flight.id" />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Sauvegarder</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import FormContent from './FlightForm';

	export default {
		components: {
			FormContent,
		},
		data() {
			return {
				showModal: false,
				flight: null,
			};
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi
					.sendForm(form, {
						weightLimit: this.$refs.form.weightLimit, // force send nullable values
						volumeLimit: this.$refs.form.volumeLimit,
						quantityLimit: this.$refs.form.quantityLimit,
					})
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							this.$toast.success('Vol modifié avec succès !');
							this.showModal = false;
							this.$emit('refresh');
						} else {
							this.$toast.error(res.data['hydra:description']);
						}
					});
			},
		},
	};
</script>
